import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common'; // ✅ thêm dòng này
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-countdown-timer',
  standalone: true, // ✅ standalone component
  imports: [CommonModule], // ✅ thêm CommonModule để dùng *ngIf, *ngFor,...
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.scss'],
})
export class CountdownTimerComponent implements OnChanges, OnDestroy {
  @Input() targetTime!: string;
  @Output() expired = new EventEmitter<void>();

  private subscription?: Subscription;
  private targetDate?: Date;

  days = 0;
  hours = 0;
  minutes = 0;
  seconds = 0;
  isExpired = false;

  ngOnInit(): void {
    if (this.targetTime) {
      this.processTargetTime(this.targetTime);
    } else {
      this.setExpired();
    }
  }

  private processTargetTime(time: string) {
    if (!time) {
      this.setExpired();
      return;
    }

    const normalized = time.replace(' ', 'T') + '+07:00';
    this.targetDate = new Date(normalized);

    if (isNaN(this.targetDate.getTime())) {
      this.setExpired();
      return;
    }

    if (this.targetDate.getTime() <= Date.now()) {
      this.setExpired();
      return;
    }

    this.startCountdown();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['targetTime'] && this.targetTime) {
        if (!this.targetTime) {
            this.setExpired();
            return;
        }
        const normalized = this.targetTime.replace(' ', 'T') + '+07:00';
        this.targetDate = new Date(normalized);
        if (isNaN(this.targetDate.getTime())) {
            this.setExpired();
            return;
        }
        if (this.targetDate.getTime() <= Date.now()) {
            this.setExpired();
            return;
        }
        this.startCountdown();
        }
    }

  private startCountdown() {
    this.subscription?.unsubscribe();
    this.isExpired = false;
    this.calculateTimeLeft();
    this.subscription = interval(1000).subscribe(() => this.calculateTimeLeft());
  }

  private calculateTimeLeft() {
        if (!this.targetDate) return;
        const now = new Date().getTime();
        const distance = this.targetDate.getTime() - now;

        if (distance <= 0) {
            this.setExpired();
            return;
        }

        // ✅ Tổng số giờ còn lại (đã quy đổi từ ngày sang giờ)
        const totalHours = Math.floor(distance / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Gán lại vào biến hiển thị
        this.days = 0;
        this.hours = totalHours;
        this.minutes = minutes;
        this.seconds = seconds;
    }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

    private setExpired() {
    this.days = this.hours = this.minutes = this.seconds = 0;
    Promise.resolve().then(() => {
        this.days = this.hours = this.minutes = this.seconds = 0;
        this.isExpired = true;
        this.expired.emit();
    });
  }
}
